// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Zmix","colMin":"styles_colMin__3NtuY","colCheckbox":"styles_colCheckbox__1EM0g"};